import { useCallback, useEffect, useState } from 'react';
import gamesService from '../../../../services/gamesService';
import type { GameMetadataMismatch } from '../../../../types/features/games';

export const useGameMetadataMismatches = () => {
  const [games, setGames] = useState<GameMetadataMismatch[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadGames = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await gamesService.getGameMetadataMismatches();
      setGames(response.data || []);
    } catch (loadError) {
      setError(loadError instanceof Error ? loadError.message : 'Failed to load game metadata mismatches');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void loadGames();
  }, [loadGames]);

  return { games, loading, error, reload: loadGames };
};
